import Input from './Input'
import NumberInput from './NumberInput'

export default Input
export { NumberInput }
